import {ConnectBasicEntity} from '../../framework/message/ConnectBasicEntity';

export class ProcessStepWriter extends ConnectBasicEntity {
cleanOnExit: boolean | null;
cleanOnExitParams: string;
cnxCode: string;
compressedFileFormat: string;
fileExtension: string;
fileName: string;
keepFileToExport: boolean | null;
processCode: string;
processStepCode: string;
sasIntegrationMode: string;
tsFileFormat: string;
visionCode: string;
writeParams: string;
writeQuery: string;
writeSchema: string;
writeTable: string;
xmlRoot: string;
}

